import { render, staticRenderFns } from "./CallLogsTable.vue?vue&type=template&id=d58a201e&scoped=true"
import script from "./CallLogsTable.vue?vue&type=script&lang=js"
export * from "./CallLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58a201e",
  null
  
)

export default component.exports